/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types */

import {
  Component,
  ViewChild,
  ViewChildren,
  QueryList,
  AfterViewInit,
  OnDestroy
}                            from '@angular/core';

import { Logger                 } from '@/util/logger';
import {
  basename,
  empty
} from '@/util/util';

import { ActionService          } from "@/services/action.service";

import { LeafletViewer       } from "@/components/leaflet/leaflet.viewer";

import * as $                     from 'jquery';
import KeyUpEvent = JQuery.KeyUpEvent;
import KeyDownEvent = JQuery.KeyDownEvent;
import {FullscreenToggleAction} from "@/components/krpano/actions/fullscreen.toggle.action";
import {OverviewNavigateById} from "@/components/leaflet/actions/overview.navigate.by.id";

@Component({
  standalone: false,
  selector: 'overwatch',
  template: `
    <div id="overwatch-inner" class="overwatch-inner">

      <!-- the leaflet inset controls zoom/reset -->
      <leaflet-controls></leaflet-controls>

      <!-- the leaflet map widget; in overview mode -->
      <leaflet-viewer-wrapper mode="overwatch"></leaflet-viewer-wrapper>

      <!-- the panorama jump to navigator -->
      <pano-selector></pano-selector>

      <!-- the bubble help we show when hovering over corridor lines or markers -->
      <div id="leaflet-popup-panel" class="leaflet-popup-panel">Popup!</div>

      </div>
`
})

/**
 *
 * @class OverwatchController
 *
 * the controller that contains the leaflet viewer (and associated controls), but for
 * the "overwatch" view (entire network).  This is basically the splash/landing page
 * users see when they first login.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class OverwatchController implements AfterViewInit, OnDestroy {

  @ViewChild(LeafletViewer)
  public         viewer: LeafletViewer;

  constructor(
    private actions: ActionService
  ) {

    Logger.debug('[OverwatchController] ctor...');
  }

  ngAfterViewInit() {

    Logger.debug('[OverwatchController] after view init...');

    /* stop key events from falling through to the browser */

    $('overwatch').on('keyup', (e: KeyUpEvent) => {

      let filterKeys: string[] = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F11'];

      if (filterKeys.findIndex(x => x == e.originalEvent.code) > -1) {

        e.preventDefault();

      }

    });

    $('overwatch').on('keydown', (e: KeyDownEvent) => {

      let filterKeys: string[] = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F11'];

      if (filterKeys.findIndex(x => x == e.originalEvent.code) > -1) {

        e.preventDefault();

      }

    });

  }

  ngOnDestroy() {

    Logger.debug('[OverwatchController] destroy...');

  }


}
